import { Component, OnInit, NgZone } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { environment } from 'src/environments/environment';


declare const google: any;

@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.scss']
})
export class ReviewsComponent implements AfterViewInit {

  showReviews = false;
  customOptions: any = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
   // autoplay: true,
    autoplayTimeout: 6000,
    autoplaySpeed: 700,
    navText: ['', ''],
    items: 2,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 1
      },
      950: {
        items: 2
      },
      3000: {
        items: 2
      }
    },
    nav: true
  }

  
  service;
  public reviews = [];

  constructor(  private zone: NgZone  ) { }

  ngAfterViewInit() {
    console.log("goin");
    const request = {
      placeId: 'ChIJI8wUGa3BfkcRHF5zEW-IsQU',
      fields: ['reviews']
    };
    this.service = new google.maps.places.PlacesService(document.getElementById('googleReviews'));

    this.service.getDetails(request, this.callback);
  
  }

  public callback = (place, status) => {
    if (status === google.maps.places.PlacesServiceStatus.OK) {
      this.zone.run( () => {
        this.reviews = place.reviews.slice();
        console.log('added');
        console.log(this.reviews);
        this.showReviews = true;
      });
      
    }
  };

  createRange(number) {
    const items: number[] = [];
    for (let i = 1; i <= number; i++) {
      items.push(i);
    }
    return items;
  }
}